import React, { useEffect} from 'react';
import { useUnistyles } from 'react-native-unistyles';
import Input from '@/components/General/inputs/Input';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { saveFolder } from '@/data/library';
import { Query } from '@/utils/react-query/Queries';
import { QueryKeys } from '@/utils/react-query/QueryKeys';
import InputSection from '@/components/General/inputs/InputSection';
import Toast from 'react-native-toast-message';
import SheetSelector from '@/components/General/inputs/SheetSelector';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { useEditScreenStore } from '@/data/store/useEditScreenStore';
import { redirectToDefault } from '@/utils/constants/linking';
import ModalWrapper from '@/components/General/ModalWrapper';
import { KeyboardAwareScrollView } from 'react-native-keyboard-controller';

const EMPTY_DRAFT = {};

export default function AddFolderModal() {
    const {id, fromScreen, fromStoreKey, parentFolderID} = useLocalSearchParams();
    const storeKey = id || "new"

    const setEditScreenData = useEditScreenStore(s => s.setEditScreenData)
    const removeEditScreenData = useEditScreenStore(s => s.removeEditScreenData)
    const folderDetails = useEditScreenStore(s => s.AddFolderModal?.[storeKey]) || EMPTY_DRAFT

    const {theme: {colors}} = useUnistyles();
    const queryClient = useQueryClient()
    const router = useRouter()

    const { data: loggedInUser } = Query.people.loggedInUser()
    const { data: folderToEdit } = Query.folders.byId({id: id, options: {enabled: !!id, placeholderData: {}}})


    useEffect(() => {
        if(folderToEdit){
            setFolderDetails(folderToEdit);
        }
    }, [folderToEdit]);

    const setFolderDetails = (details) => setEditScreenData("AddFolderModal", storeKey, details)


    const saveFolderMutation = useMutation({
        mutationFn: saveFolder,
        onSuccess: (data) => {
            queryClient.invalidateQueries({queryKey: QueryKeys.folders.byId(parentFolderID)});
            queryClient.invalidateQueries({queryKey: QueryKeys.folders.byId('ROOT')});
            removeEditScreenData("AddFolderModal", storeKey)

            if(fromScreen){
                useEditScreenStore.getState().dataChangeFunction?.(data)
                router.dismissTo({pathname:fromScreen, params: fromStoreKey && fromStoreKey != "new" ? {id: fromStoreKey} : undefined});
            }
            else{
                redirectToDefault(router, "AddFolderModal")
            }
        }
    })
    
    return (
        <ModalWrapper 
            loading={saveFolderMutation.isPending} 
            onConfirm={() => {
                const regex = new RegExp(/^[a-z 0-9_-]+$/i);
                if(!regex.test(folderDetails.name)){
                    Toast.show({type: 'error', text2: "Folder name can only contain letters, numbers, spaces, hyphens, and underscores!"})
                    return;
                }

                saveFolderMutation.mutate({
                    ...folderDetails,
                    parentFolderID: parentFolderID, 
                    createdByID: loggedInUser?.id
                })
            }} 
            title="New Folder"
        >
            <KeyboardAwareScrollView bottomOffset={100} keyboardShouldPersistTaps="handled">
            <InputSection>
                <Input
                    isNotOnSurface
                    title="Folder Name"
                    maxLength={120}
                    backgroundColor={colors.surface}
                    value={folderDetails.name}
                    onUpdate={(new_value) => {
                        setFolderDetails({...folderDetails, name: new_value})
                    }}
                />

                <SheetSelector isNotOnSurface multiple type="roles" title="Roles" fromScreen={`library/folders/create`} fromStoreKey={storeKey} value={folderDetails.Roles || []} onChange={(selected_items) => {
                        setFolderDetails({...folderDetails, Roles: selected_items})
                    }} 
                />
            </InputSection>
        </KeyboardAwareScrollView>
        </ModalWrapper>
    );
}